<template>
  <div class="p-fluid">
    <div class="p-col-12 p-lg-12">
      <div class="card card-w-title">
        <div class="manager-title-custom">{{ title }}</div>
        <formEdit :key="componentKey" :mode="mode" @back="backToList" @save="saveData" :model="models" />
      </div>
    </div>
  </div>
</template>

<script>
import formEdit from "./add";
import ApiRepository from "@/core/ApiRepository";

export default {
  components: {
    formEdit,
  },
  data() {
    return {
      users: null,
      validationErrors: [],
      title: "Thêm mới khu vực",
      mode: "add",
      models: {},
      componentKey: 0,
      accountID: "",
      page_transaction: null,
      company_id: null,
    };
  },
  async mounted() {
    this.mode = this.$route.name === "editZone" ? "edit" : this.mode;
    this.title = this.mode === "edit" ? "Chỉnh sửa khu vực" : this.title;
    if (!this.$commonFuction.isEmpty(this.$route.query)) {
      if (!this.$commonFuction.isEmpty(this.$route.query.page_transaction)) {
        this.page_transaction = this.$route.query.page_transaction;
      }
      if (!this.$commonFuction.isEmpty(this.$route.query.company_id)) {
        this.company_id = this.$route.query.company_id;
      }
    }
    if (this.$route.params.id !== undefined) await this.getData(this.$route.params.id);
  },
  methods: {
    backToList() {
      this.$router.push({ path: "/admin/list-zone", query: { company_id: this.company_id } });
    },
    async saveData(params) {
      var that = this;
      let objects = {
        name: params.name,
        company_id: params?.company ? params.company.id : null,
        active: params.active,
      };
      this.company_id = params?.company ? params.company.id : this.company_id;
      var token = that.$store.getters.token ? that.$store.getters.token : null;
      if (token) {
        const headers = {
          Authorization: "Bearer " + token,
        };
        if (this.mode == "add") {
          await ApiRepository.post("/_api/zone/create", objects, { headers })
            .then(async function (response) {
              if (response.status === 200) {
                that.redirectEdit();
              } else {
                that.$toast.add({ severity: "error", summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG, detail: response.data.message, life: 3000 });
                that.$commonFuction.is_loading(false);
              }
            })
            .catch((err) => {
              console.log(err);
              that.$toast.add({ severity: "error", summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG, detail: err, life: 3000 });
              that.$commonFuction.is_loading(false);
            });
        } else {
          objects.id = this.$route.params.id;
          await ApiRepository.post("/_api/zone/update", objects, { headers })
            .then(async function (response) {
              if (response.status === 200) {
                that.redirectEdit();
              } else {
                that.$toast.add({ severity: "error", summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG, detail: response.data.message, life: 3000 });
                that.$commonFuction.is_loading(false);
              }
            })
            .catch((err) => {
              console.log(err);
              that.$toast.add({ severity: "error", summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG, detail: err, life: 3000 });
              that.$commonFuction.is_loading(false);
            });
        }
      }
    },
    async redirectEdit() {
      var that = this;
      var router_back = { path: "/admin/list-zone" };
      that.$commonFuction.is_loading(false);
      if (that.mode == "add") {
        router_back.query = { company_id: this.company_id };
        that.$router.push(router_back);
      } else {
        router_back.query = { page_transaction: this.page_transaction.toString(), company_id: this.company_id };
        that.$router.push(router_back);
      }
      that.$toast.add({ severity: "success", summary: "Success", detail: "Lưu dữ liệu thành công", life: 3000 });
    },
    async getData(id) {
      var token = this.$store.getters.token ? this.$store.getters.token : null;
      if (token) {
        const headers = {
          Authorization: "Bearer " + token,
        };
        var { data } = await ApiRepository.post("/_api/zone/detail", { id: id, company_id: this.company_id }, { headers });
        this.models = data.data;
        this.componentKey++;
      }
    },
  },
};
</script>

<style lang="scss">
.manager-title-custom {
  color: #1d3118;
  font-size: 18px;
  margin-bottom: 16px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eeeeee;
  font-weight: 700;
}
.p-inputnumber-buttons-stacked {
  .p-inputnumber-button-group {
    .p-button.p-button-icon-only {
      padding: 0 !important;
    }
  }
}
.note {
  letter-spacing: 0px;
  color: #707070;
  margin-bottom: 24px;
  padding-top: 10px;
}
.p-formgrid {
  margin: 0;
  .p-panel-header {
    color: #000000;
    font-size: 18px;
    font-weight: bold;
    background: #eeeeee;
  }
  .p-card-field {
    padding: 24px;
    .p-field {
      .p-col-fixed {
        width: 300px;
        display: inline-block !important;
        margin: 0;
      }
      .p-col-width {
        width: 500px !important;
        border-radius: 5px;
        &.disabled {
          background: #eeeeee;
          border: 0 none;
          padding: 8px 10px;
        }
      }
      .p-invalid {
        display: block;
      }
    }
  }
  .fixed-bottom-toolbar {
    background: transparent;
    border: 0 none;
    margin-top: 22px;
    border-top: 1px solid #b4b4b4;
    padding: 0;
    padding-top: 30px;
    .p-button {
      width: auto;
      margin-right: 8px;
      &:last-child {
        margin-right: 0;
      }
    }
  }
}
</style>
